module.exports = __webpack_public_path__ + "img/09.b9f6355e.jpg";